import React from 'react';
function FinanceStat() {
    return ( <>
    </> );
}

export default FinanceStat;